import React from "react";
import "../WhyChoose.css";

const WhyChoose = () => {
  return (
    <div className="about-section mt-2 pt-1 mb-1">
      <div className="container mb-5">
        <div class="row">
          <div className="sec-title text-center">
            <span className="title">Why Choose Us</span>
            <h2>
              We are leader in <br /> Industrial market Since 2023
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
            <div className="inner-column">
              <div className="about-text">
               At DigiOpen Services, we combine innovation, technical expertise, and industry best practices to deliver digital solutions tailored to the unique requirements of your business. Our customer-centric approach ensures that every solution is intuitive, scalable, and designed to maximize operational efficiency and business value.
              </div>
                <div className="about-text">
From comprehensive business analysis and strategic planning to design, development, implementation, and ongoing support, we provide end-to-end services that ensure a seamless digital transformation journey. We are committed to delivering projects on time and within budget while maintaining the highest standards of quality and performance.</div>
 <div className="about-text">By continuously adopting emerging technologies and industry advancements, we help businesses stay agile, competitive, and future-ready. Through transparent communication, collaborative partnerships, and a focus on measurable outcomes, we strive to build long-term relationships and deliver solutions that drive sustainable growth and success.</div>
              <ul className="list-style-one pt-1 d-flex flex-wrap">
                <li className="col-6 mb-2">Expertise  You  Can Trust</li>
                <li className="col-6 mb-2">Customer-Centric Approach</li>
                <li className="col-6 mb-2">Affordable & Flexible</li>
                <li className="col-6 mb-2">End-to-End Support</li>
                <li className="col-6 mb-2">Innovative Solutions</li>
                <li className="col-6 mb-2">On-Time Delivery</li>
              </ul>
            </div>
          </div>

          <div className="image-column col-lg-6 col-md-12 col-sm-12">
            <div className="inner-column wow fadeInLeft mb-5">
              <figure className="image-1 ">
                
                  <img
                    src="img/productidea.jpg"
                    alt="Why Choose 1"
                    className="rounded-3"
                    width="100%"
                  />
             
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;